import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { isMobile } from 'react-device-detect';
import { IS_IFRAME_MODE } from 'config/envVariable';
import ShareIconButton from '../ShareIconButton';

const FacebookShareButton = ({ url }) => {
    const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    const handleClick = () => {
        if (isMobile) {
            if (IS_IFRAME_MODE) window.top.location = fbShareUrl;
            else window.location.href = fbShareUrl;
        } else window.open(fbShareUrl, '', 'toolbar=0,status=0,width=580,height=325');
    };
    return (
        <ShareIconButton
            variant="contained"
            text="Facebook"
            bgColor="#3b5998"
            imageUrl="https://assets.fevercdn.com/promotion/img/facebook.svg"
            size={28}
            onClick={handleClick}
            style={facebookButtonStyle}
        />
    );
};

export default FacebookShareButton;

FacebookShareButton.propTypes = {
    url: PropTypes.string
};

const facebookButtonStyle = css`
    color: #ffffff;
    padding: 10px;

    * > img {
        scale: 1.7;
    }
`;
